import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createAddJackpotModel } from 'features/add-jackpot';
import { createBlockJackpotModel } from 'features/block-jackpot';
import { createDeleteJackpotModel } from 'features/delete-jackpot';
import { createEditJackpotModel } from 'features/edit-jackpot';
import { createUnblockJackpotModel } from 'features/unblock-jackpot';
import { accountTreeModel } from 'entities/account';
import { createJackpotRegistryModel } from 'entities/jackpot';

const addJackpotModel = createAddJackpotModel();

const editJackpotModel = createEditJackpotModel();

const blockJackpotModel = createBlockJackpotModel();

const unblockJackpotModel = createUnblockJackpotModel();

const deleteJackpotModel = createDeleteJackpotModel();

const jackpotRegistryModel = createJackpotRegistryModel({
	$currencies: accountTreeModel.$currencies,
	onDelete: [deleteJackpotModel.mutation.finished.success],
	onUpdate: [
		addJackpotModel.addJackpotMutation.finished.success,
		editJackpotModel.editJackpotMutation.finished.success,
		blockJackpotModel.mutation.finished.success,
		unblockJackpotModel.mutation.finished.success,
	],
});

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: jackpotRegistryModel.model.filters.accountIds.setValue,
});

chain(jackpotRegistryModel.model.clearFilters, accountTreeModel.clearSelectedNodes);

export const jackpotsPageModel = {
	jackpotRegistryModel,
	deleteJackpotModel,
	addJackpotModel,
	editJackpotModel,
	blockJackpotModel,
	unblockJackpotModel,
};
